import { render } from "./dialogThanksMail.vue?vue&type=template&id=07619ba0&scoped=true"
import script from "./dialogThanksMail.vue?vue&type=script&lang=js"
export * from "./dialogThanksMail.vue?vue&type=script&lang=js"

import "./dialogThanksMail.vue?vue&type=style&index=0&id=07619ba0&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07619ba0"]])

export default __exports__